import { useEffect, useState } from "react";
import { vpAxios, money } from "../api";
import { toast } from "sonner";
import { Plus, Trash2, Pencil, MapPin, Save, Ban, Truck } from "lucide-react";

export default function TaxasEntregaPage() {
  const [regs, setRegs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [freteGratisMin, setFreteGratisMin] = useState(0);
  const [savingMin, setSavingMin] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [{ data: rs }, { data: cfg }] = await Promise.all([
        vpAxios.get("/vaipede/entrega/regioes"),
        vpAxios.get("/vaipede/entrega/config"),
      ]);
      setRegs(rs); setFreteGratisMin(cfg.frete_gratis_min);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const salvarMin = async () => {
    setSavingMin(true);
    try {
      await vpAxios.put("/vaipede/entrega/config", { frete_gratis_min: parseFloat(freteGratisMin) || 0 });
      toast.success("Configuração salva");
    } catch (e) { toast.error("Erro"); }
    finally { setSavingMin(false); }
  };

  const excluir = async (r) => {
    if (!window.confirm(`Excluir a região "${r.bairro}"?`)) return;
    try {
      await vpAxios.delete(`/vaipede/entrega/regioes/${r.id}`);
      toast.success("Região excluída"); load();
    } catch (e) { toast.error("Erro"); }
  };

  const bloquearToggle = async (r) => {
    try {
      await vpAxios.put(`/vaipede/entrega/regioes/${r.id}`, { bloqueado: !r.bloqueado });
      toast.success(r.bloqueado ? "Região desbloqueada" : "Região bloqueada");
      load();
    } catch (e) { toast.error("Erro"); }
  };

  return (
    <div data-testid="vaipede-taxas-entrega">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h1 className="text-2xl font-black flex items-center gap-2"><Truck className="w-6 h-6 text-[#EA1D2C]"/> Taxas de Entrega</h1>
          <p className="text-sm text-neutral-500">Configure taxas por bairro e frete grátis</p>
        </div>
        <button onClick={() => { setEditing(null); setShowForm(true); }} className="px-4 py-2.5 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm flex items-center gap-2" data-testid="vaipede-regiao-nova">
          <Plus className="w-4 h-4"/> Nova região
        </button>
      </div>

      {/* Frete grátis global */}
      <div className="bg-emerald-50 border-2 border-emerald-200 rounded-2xl p-4 mb-5">
        <div className="text-xs font-bold text-emerald-800 uppercase tracking-wide">🎁 Frete grátis a partir de</div>
        <p className="text-xs text-emerald-700/80 mb-2">Se o pedido atingir esse valor, a taxa é zerada (mesmo em bairros pagos). Use 0 para desativar.</p>
        <div className="flex gap-2 items-center">
          <span className="text-sm font-bold">R$</span>
          <input type="number" step="0.01" value={freteGratisMin} onChange={e => setFreteGratisMin(e.target.value)} className="px-3 py-2 rounded-xl border border-emerald-300 text-sm w-32" data-testid="vaipede-frete-min-input"/>
          <button onClick={salvarMin} disabled={savingMin} className="px-4 py-2 rounded-xl bg-emerald-600 text-white font-bold text-sm flex items-center gap-1" data-testid="vaipede-frete-min-salvar">
            <Save className="w-3.5 h-3.5"/> {savingMin ? "Salvando" : "Salvar"}
          </button>
        </div>
      </div>

      {/* Lista de regiões */}
      {loading ? <div className="text-neutral-500 text-sm">Carregando...</div> :
       regs.length === 0 ? (
        <div className="bg-white rounded-2xl border-2 border-dashed border-neutral-300 p-8 text-center">
          <MapPin className="w-8 h-8 mx-auto text-neutral-300 mb-2"/>
          <p className="text-neutral-500 text-sm">Nenhum bairro cadastrado — clique em "Nova região" acima.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {regs.map(r => (
            <div key={r.id} className={`bg-white rounded-2xl border-2 p-4 ${r.bloqueado ? "border-red-300 opacity-70" : r.frete_gratis ? "border-emerald-400" : "border-neutral-200"}`} data-testid={`vaipede-regiao-${r.id}`}>
              <div className="flex items-start justify-between gap-2 mb-1">
                <div>
                  <div className="font-black">{r.bairro}</div>
                  {r.cidade && <div className="text-xs text-neutral-500">{r.cidade}</div>}
                </div>
                <div className="flex gap-1">
                  <button onClick={() => { setEditing(r); setShowForm(true); }} className="p-1.5 rounded-lg bg-neutral-100" data-testid={`vaipede-regiao-editar-${r.id}`}>
                    <Pencil className="w-3.5 h-3.5"/>
                  </button>
                  <button onClick={() => bloquearToggle(r)} className={`p-1.5 rounded-lg ${r.bloqueado ? "bg-red-100 text-red-600" : "bg-neutral-100"}`} data-testid={`vaipede-regiao-bloq-${r.id}`}>
                    <Ban className="w-3.5 h-3.5"/>
                  </button>
                  <button onClick={() => excluir(r)} className="p-1.5 rounded-lg bg-red-50 text-red-600" data-testid={`vaipede-regiao-del-${r.id}`}>
                    <Trash2 className="w-3.5 h-3.5"/>
                  </button>
                </div>
              </div>
              {r.bloqueado ? (
                <div className="mt-2 text-xs text-red-600 font-bold">🚫 Não atendemos</div>
              ) : r.frete_gratis ? (
                <div className="mt-2 text-xs text-emerald-700 font-bold">🎁 FRETE GRÁTIS</div>
              ) : (
                <div className="mt-2 text-lg font-black text-[#EA1D2C]">{money(r.taxa)}</div>
              )}
              {r.obs_bloqueio && <div className="text-[11px] text-neutral-500 mt-1">{r.obs_bloqueio}</div>}
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <RegiaoForm
          initial={editing}
          onClose={() => { setShowForm(false); setEditing(null); }}
          onSaved={() => { setShowForm(false); setEditing(null); load(); }}
        />
      )}
    </div>
  );
}

function RegiaoForm({ initial, onClose, onSaved }) {
  const [f, setF] = useState(initial || { bairro: "", cidade: "", taxa: "", frete_gratis: false, bloqueado: false, obs_bloqueio: "" });
  const [saving, setSaving] = useState(false);

  const salvar = async () => {
    if (!f.bairro.trim()) return toast.error("Bairro é obrigatório");
    setSaving(true);
    try {
      const payload = { ...f, taxa: parseFloat(f.taxa) || 0 };
      if (initial?.id) {
        await vpAxios.put(`/vaipede/entrega/regioes/${initial.id}`, payload);
      } else {
        await vpAxios.post("/vaipede/entrega/regioes", payload);
      }
      toast.success("Região salva");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao salvar");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-5 max-h-[92vh] overflow-auto">
        <h2 className="font-black text-lg mb-4">{initial ? "Editar região" : "Nova região"}</h2>
        <div className="space-y-2">
          <div>
            <label className="text-[11px] font-bold text-neutral-500">Bairro/Região*</label>
            <input value={f.bairro} onChange={e => setF({...f, bairro: e.target.value})} className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" placeholder="Ex: Centro" data-testid="vaipede-regiao-input-bairro"/>
          </div>
          <div>
            <label className="text-[11px] font-bold text-neutral-500">Cidade (opcional)</label>
            <input value={f.cidade} onChange={e => setF({...f, cidade: e.target.value})} className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" placeholder="Ex: Campo Grande"/>
          </div>
          <div>
            <label className="text-[11px] font-bold text-neutral-500">Valor da taxa (R$)</label>
            <input type="number" step="0.01" value={f.taxa} onChange={e => setF({...f, taxa: e.target.value})} className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" placeholder="0,00" data-testid="vaipede-regiao-input-taxa"/>
          </div>
          <label className="flex items-center gap-2 py-2 text-sm">
            <input type="checkbox" checked={f.frete_gratis} onChange={e => setF({...f, frete_gratis: e.target.checked})} data-testid="vaipede-regiao-input-fg"/>
            <span>🎁 Frete grátis nesta região</span>
          </label>
          <label className="flex items-center gap-2 py-2 text-sm">
            <input type="checkbox" checked={f.bloqueado} onChange={e => setF({...f, bloqueado: e.target.checked})} data-testid="vaipede-regiao-input-bloq"/>
            <span>🚫 Não atendemos essa região</span>
          </label>
          {f.bloqueado && (
            <div>
              <label className="text-[11px] font-bold text-neutral-500">Motivo (aparecerá para o cliente)</label>
              <input value={f.obs_bloqueio} onChange={e => setF({...f, obs_bloqueio: e.target.value})} className="w-full px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" placeholder="Ex: Fora da área de cobertura"/>
            </div>
          )}
        </div>
        <div className="flex gap-2 mt-5">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-xl bg-neutral-100 font-bold text-sm">Cancelar</button>
          <button onClick={salvar} disabled={saving} className="flex-1 py-2.5 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm" data-testid="vaipede-regiao-salvar">
            {saving ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}
